export default __webpack_public_path__ + "static/media/locationicon.566d2188.svg";